import React from 'react';
import skincareProDao from '../dao/skincareProDao';
import SkincareProDao from '../dao/skincareProDao';
import SparkMD5 from 'spark-md5';
import {toast} from 'react-toastify';
import smbUtils from './smbUtils';
import JSZip from 'jszip';
import _cloneDeep from 'lodash/cloneDeep';
import _uniq from 'lodash/uniq';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {Trans} from 'react-i18next';
import _isNil from 'lodash/isNil';
import v1tov2Utils from '../pages/skincarepro/uiconfiguration/config/utils/v1tov2Utils';
import _indexOf from 'lodash/indexOf';
import subscriptionUtils from './subscriptionUtils';
import i18n from './i18n';
import _find from 'lodash/find';
import licenseDao from '../dao/licenseDao';
import {multipleSubscriptionsUtils} from './solutionUtils';
import planUtils from './planUtils';
import skinDetectionCategories from './config/skinDetectionCategories';
import {downloadFile} from './clientUtils';
import {ReactComponent as EyebrowsSVG} from '../assets/images/skincare/simulation/ico_simulation_category_brows.svg';
import {ReactComponent as FaceSVG} from '../assets/images/skincare/simulation/ico_simulation_category_face.svg';
import {ReactComponent as EyesSVG} from '../assets/images/skincare/simulation/ico_simulation_category_eyes.svg';
import {ReactComponent as LipsSVG} from '../assets/images/skincare/simulation/ico_simulation_category_lips.svg';
import {ReactComponent as NoseSVG} from '../assets/images/skincare/simulation/ico_simulation_category_nose.svg';
import {ReactComponent as SkinSVG} from '../assets/images/skincare/simulation/ico_simulation_category_skin.svg';

const zipGenerate = async (
  pageConfig,
  type,
  token,
  customerId,
  files = null
) => {
  let zip = new JSZip();
  await zip.file(
    'page-config.js',
    'window.__PF_CONSOLE_PAGE_CONFIG__ = ' + JSON.stringify(pageConfig)
  );
  const timestamp = new Date().getTime();
  files &&
    files.map(async f => {
      f.file !== '' &&
        (await zip.file(
          `assets/image/${f.fileName}`,
          urlToFile(f.file + `?${timestamp}`)
        ));
    });

  const zipBlob = await zip.generateAsync({type: 'blob'});
  // const link = document.createElement('a');
  // link.href = URL.createObjectURL(zipBlob);
  // link.download = 'sample.zip';
  // link.click();
  // URL.revokeObjectURL(link.href);
  return await uploadFile(
    type,
    zipBlob,
    '',
    '',
    'TemplateZip',
    token,
    customerId
  );
};

const urlToFile = async image => {
  const response = await fetch(image);
  const blob = await response.blob();
  return new File([blob], 'image.jpg', {type: blob.type});
};

const dataURLtoFile = (dataUrl, filename) => {
  let arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type: mime});
};

const handleImage = async (image, token, customerId) => {
  if (!image) return '';
  if (smbUtils.isUrl(image)) return image;
  let img = new Image();
  img.src = image;
  await img.decode();
  const width = img.width;
  const height = img.height;
  const file = dataURLtoFile(image);
  return await uploadFile(
    'result',
    file,
    width,
    height,
    'TemplateImage',
    token,
    customerId
  );
};

const getTemplateDefaultConfig = (pageType, mode, version = 1, customerId) => {
  const tmp = new FormData();
  tmp.append('pageType', pageType);
  if (!_isEmpty(mode)) {
    tmp.append('mode', mode);
  }
  tmp.append('version', version);
  tmp.append('customerId', customerId);
  return skincareProDao.getTemplateDefaultConfig(tmp);
};

const productTypes = [
  {type1: 'Store', type2: 'SMB', type3: 'SMB_PRODUCT'},
  {type1: 'Store', type2: 'SMB', type3: 'SMB_ROUTINE'},
  {type1: 'Store', type2: 'SMB', type3: 'SMB_TREATMENT'},
];

const productTypesName = [
  {
    type: 'SMB_PRODUCT',
    name: (
      <Trans i18nKey="p.e.addoreditframe.basic.info.frame.category">
        Product
      </Trans>
    ),
  },
  {
    type: 'SMB_ROUTINE',
    name: <Trans i18nKey="p.s.listskincareroutine.routine">Routine</Trans>,
  },
  {
    type: 'SMB_TREATMENT',
    name: (
      <Trans i18nKey="p.s.recommendation.addoreditcase.set.case.add.treatment">
        Treatment
      </Trans>
    ),
  },
];

const uploadFile = async (
  templateType,
  file,
  width,
  height,
  fileType,
  token,
  customerId,
  returnAll = false
) => {
  function generateMetaData(arrBuffer, file, width, height) {
    const sparkMD5 = new SparkMD5.ArrayBuffer();
    sparkMD5.append(arrBuffer);
    const md5 = sparkMD5.end();
    return {
      fileSize: file.size,
      md5: md5,
      width: width,
      height: height,
      orientation: 1,
    };
  }
  function generateFileMetaData(buffer, file, width, height) {
    const sparkMD5 = new SparkMD5();
    sparkMD5.appendBinary(buffer);
    const MD5 = sparkMD5.end();
    return {
      orientation: 1,
      fileSize: file.size,
      md5: MD5,
      width: 0,
      height: 0,
    };
  }

  if (!file) {
    return;
  }
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  const data = new FormData();
  let meta = '';
  if (fileType === 'TemplateZip') {
    reader.onloadend = function(e) {
      meta = generateFileMetaData(e.target.result, file);
    };
  } else {
    reader.onloadend = function(e) {
      meta = generateMetaData(e.target.result, file, width, height);
    };
  }
  if (_isNil(token) || _isNil(customerId)) {
    data.append('file_type', fileType);
    data.append('metadata', JSON.stringify({}));
    data.append('optimize', false);
    data.append('ratio', 1);
    data.append('file', file);

    return await SkincareProDao.uploadFileV2(data)
      .then(json => {
        if (returnAll) {
          return json;
        }
        if (json.status === 'fail') {
          toast.error('fail');
        }
        if (fileType === 'TemplateZip') {
          return json.fileId;
        }
        if (json.url) {
          return json.url;
        } else {
          return '';
        }
      })
      .catch(error => console.error(error));
  } else data.append('token', token);
  data.append('customerId', customerId);
  data.append('fileType', fileType);
  data.append('fileBean', file);
  data.append('metadata', JSON.stringify(meta));
  return await SkincareProDao.uploadFile(data)
    .then(json => {
      if (returnAll) {
        return json;
      }
      if (json.status === 'fail') {
        toast.error('fail');
      }
      if (fileType === 'TemplateZip') {
        return json.fileId;
      }
      if (json.originalUrl) {
        return json.originalUrl;
      } else {
        return '';
      }
    })
    .catch(error => console.error(error));
};

const listDevices = (token, customerId) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  return licenseDao.listDevices(tmp);
};

const getOverview = (
  token,
  customerId,
  accountId,
  solutionType,
  granularity,
  sinceTime,
  untilTime,
  storeId
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('solutionType', solutionType);
  if (!_isNil(accountId)) {
    tmp.append('accountId', accountId);
  }
  if (granularity) {
    tmp.append('granularity', granularity);
  }
  if (sinceTime) {
    tmp.append('sinceTime', sinceTime);
  }
  if (untilTime) {
    tmp.append('untilTime', untilTime);
  }
  if (!_isNil(storeId)) {
    tmp.append('storeId', storeId);
  }
  return skincareProDao.getOverview(tmp);
};

const getImpression = (
  token,
  customerId,
  solutionType,
  accountId,
  granularity = 'week',
  sinceTimePicker = '2022-01-02',
  untilTimePicker = '2022-01-23',
  storeId
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('solutionType', solutionType);
  if (!_isNil(accountId)) {
    tmp.append('accountId', accountId);
  }
  tmp.append('granularity', granularity);
  tmp.append('sinceTimePicker', sinceTimePicker);
  tmp.append('untilTimePicker', untilTimePicker);
  if (!_isNil(storeId)) {
    tmp.append('storeId', storeId);
  }
  return skincareProDao.getImpression(tmp);
};

const getDiagnostic = (
  token,
  customerId,
  solutionType,
  accountId,
  granularity = 'week',
  sinceTimePicker = '2022-01-02',
  untilTimePicker = '2022-01-23',
  storeId
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('solutionType', solutionType);
  if (!_isNil(accountId)) {
    tmp.append('accountId', accountId);
  }
  tmp.append('granularity', granularity);
  tmp.append('sinceTimePicker', sinceTimePicker);
  tmp.append('untilTimePicker', untilTimePicker);
  if (!_isNil(storeId)) {
    tmp.append('storeId', storeId);
  }
  return skincareProDao.getDiagnostic(tmp);
};

const getGetReport = (
  token,
  customerId,
  solutionType,
  accountId,
  granularity = 'week',
  sinceTimePicker = '2022-01-02',
  untilTimePicker = '2022-01-23',
  storeId
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('solutionType', solutionType);
  if (!_isNil(accountId)) {
    tmp.append('accountId', accountId);
  }
  tmp.append('granularity', granularity);
  tmp.append('sinceTimePicker', sinceTimePicker);
  tmp.append('untilTimePicker', untilTimePicker);
  if (!_isNil(storeId)) {
    tmp.append('storeId', storeId);
  }
  return skincareProDao.getGetReport(tmp);
};

const getSessionStart = (
  token,
  customerId,
  solutionType,
  accountId,
  granularity = 'week',
  sinceTimePicker = '2022-01-02',
  untilTimePicker = '2022-01-23',
  storeId
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('solutionType', solutionType);
  if (!_isNil(accountId)) {
    tmp.append('accountId', accountId);
  }
  tmp.append('granularity', granularity);
  tmp.append('sinceTimePicker', sinceTimePicker);
  tmp.append('untilTimePicker', untilTimePicker);
  if (!_isNil(storeId)) {
    tmp.append('storeId', storeId);
  }
  return skincareProDao.getSessionStart(tmp);
};

const treatmentTypes = [
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.cheek.fillers">
        Cheek Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.cheek.fillers',
    value: 'cheek_fillers',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_cheek.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.forehead.lines">
        Forehead Lines
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.forehead.lines',
    value: 'forehead_lines',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_forehead.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.glabellar.lines">
        Glabellar Lines
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.glabellar.lines',
    value: 'glabellar_lines',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_glabellar.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.jawline.contouring">
        Jawline Contouring
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.jawline.contouring',
    value: 'jawline_contouring',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_jaw.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nasolabial.folds">
        Nasolabial Folds
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nasolabial.folds',
    value: 'nasolabial_folds',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_nasolabial.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.marionette.folds">
        Marionette Folds
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.marionette.folds',
    value: 'marionette_folds',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_marionette.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.chin.fillers">
        Chin Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.chin.fillers',
    value: 'chin_fillers',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_chin.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.temples.fillers">
        Temples Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.temples.fillers',
    value: 'temples_fillers',
    type: 'face',
    icon: require('../assets/images/skincare/simulation/ico_simulation_face_temple.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.eyebrow.lifts">
        Eyebrows Lifts
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.eyebrow.lifts',
    value: 'eyebrow_lifts',
    type: 'eyebrows',
    icon: require('../assets/images/skincare/simulation/ico_simulation_eye_brow.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.crow.feet">
        Crow's Feet
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.crow.feet',
    value: 'crow_feet',
    type: 'eyes',
    icon: require('../assets/images/skincare/simulation/ico_simulation_eye_crowsfeet.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.dark.circle">
        Dark Circle
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.dark.circle',
    value: 'dark_circle',
    type: 'eyes',
    icon: require('../assets/images/skincare/simulation/ico_simulation_eye_dc.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.eyebag">
        Eyebag
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.eyebag',
    value: 'eyebag',
    type: 'eyes',
    icon: require('../assets/images/skincare/simulation/ico_simulation_eye_eyebag.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.periocular">
        Periocular
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.periocular',
    value: 'periocular',
    type: 'eyes',
    icon: require('../assets/images/skincare/simulation/ico_simulation_eye_periocular.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.lip.plumper">
        Lip Plumper
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.lip.plumper',
    value: 'lip_plumper',
    type: 'lips',
    icon: require('../assets/images/skincare/simulation/ico_simulation_lip_plumper.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.cupid.bow">
        Cupid’s Bow
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.cupid.bow',
    value: 'cupid_bow',
    type: 'lips',
    icon: require('../assets/images/skincare/simulation/ico_simulation_lip_cupidsbow.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.upper.lip.fillers">
        Upper Lip Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.upper.lip.fillers',
    value: 'upper_lip_fillers',
    type: 'lips',
    icon: require('../assets/images/skincare/simulation/ico_simulation_lip_upper.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.lower.lip.fillers">
        Lower Lip Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.lower.lip.fillers',
    value: 'lower_lip_fillers',
    type: 'lips',
    icon: require('../assets/images/skincare/simulation/ico_simulation_lip_lower.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.corner.lip.lift.fillers">
        Corner Lip Lift Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.corner.lip.lift.fillers',
    value: 'corner_lip_lift_fillers',
    type: 'lips',
    icon: require('../assets/images/skincare/simulation/ico_simulation_lip_cornerlift.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nose.contouring">
        Nose Contouring
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nose.contouring',
    value: 'nose_contouring',
    type: 'nose',
    icon: require('../assets/images/skincare/simulation/ico_simulation_nose_contour.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nose.tip.lift.fillers">
        Nose Tip Lift Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nose.tip.lift.fillers',
    value: 'nose_tip_lift_fillers',
    type: 'nose',
    icon: require('../assets/images/skincare/simulation/ico_simulation_nose_tip.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nose.slimming.fillers">
        Nose Slimming Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nose.slimming.fillers',
    value: 'nose_slimming_fillers',
    type: 'nose',
    icon: require('../assets/images/skincare/simulation/ico_simulation_nose_slim.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nose.bridge.fillers">
        Nose Bridge Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nose.bridge.fillers',
    value: 'nose_bridge_fillers',
    type: 'nose',
    icon: require('../assets/images/skincare/simulation/ico_simulation_nose_bridge.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.nose.root.fillers">
        Nose Root Fillers
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.nose.root.fillers',
    value: 'nose_root_fillers',
    type: 'nose',
    icon: require('../assets/images/skincare/simulation/ico_simulation_nose_root.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.texture">
        Texture
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.texture',
    value: 'texture',
    type: 'skin',
    icon: require('../assets/images/skincare/simulation/ico_simulation_skin_texture.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.pores">Pores</Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.pores',
    value: 'pores',
    type: 'skin',
    icon: require('../assets/images/skincare/simulation/ico_simulation_skin_pores.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.spots">Spots</Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.spots',
    value: 'spots',
    type: 'skin',
    icon: require('../assets/images/skincare/simulation/ico_simulation_skin_spots.png'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.treatment.type.redness">
        Redness
      </Trans>
    ),
    i18n: 'u.c.globals.simulation.treatment.type.redness',
    value: 'redness',
    type: 'skin',
    icon: require('../assets/images/skincare/simulation/ico_simulation_skin_red.png'),
  },
];

const facialZones = [
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.face">Face</Trans>
    ),
    value: 'face',
    isPremium: false,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_face.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_faces.png'),
    icon_svg: <FaceSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.skin">Skin</Trans>
    ),
    value: 'skin',
    isPremium: true,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_skin.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_skins.png'),
    icon_svg: <SkinSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.eyebrows">
        Eyebrows
      </Trans>
    ),
    value: 'eyebrows',
    isPremium: false,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_brows.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_browss.png'),
    icon_svg: <EyebrowsSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.eyes">Eyes</Trans>
    ),
    value: 'eyes',
    isPremium: true,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_eyes.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_eyess.png'),
    icon_svg: <EyesSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.nose">Nose</Trans>
    ),
    value: 'nose',
    isPremium: true,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_nose.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_noses.png'),
    icon_svg: <NoseSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.lips">Lips</Trans>
    ),
    value: 'lips',
    isPremium: false,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_lips.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_lipss.png'),
    icon_svg: <LipsSVG />,
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.facial.zones.skin">Skin</Trans>
    ),
    value: 'skin',
    isPremium: true,
    icon_default: require('../assets/images/skincare/simulation/ico_simulation_category_skin.png'),
    icon_pink: require('../assets/images/skincare/simulation/ico_simulation_category_skins.png'),
    icon_svg: <SkinSVG />,
  },
];

const faceAssessmentCategory = [
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/3rule">
        Face 1/3 Rule
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/3rule.desc1">
        The golden ratio of the Face 1/3 Rule is based on dividing the face
        vertically into three equal sections: from the hairline to the bottom of
        the eyebrows, from the bottom of eyebrows to the bottom of the nose, and
        from the bottom of the nose to the tip of the chin. The ideal proportion
        is <b>1:1:1(33%:33%:33%)</b>.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/3rule.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'face1_3Rule',
    ratio: '33%, 33%, 33%',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_1_3_rule.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_1_3rule.jpg'),
    image_portrait_ratio_position: {width: '75%', height: '65%', top: '65px'},
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_1_3rule.jpg'),
    image_landscape_ratio_position: {width: '65%', height: '60%', top: '60px'},
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_1_3face.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/5rule">
        Face 1/5 Rule
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/5rule.desc1">
        The golden ratio of the Face 1/5 Rule is determined by dividing the face
        horizontally into five equal sections: the width of one eye, the
        distance between the eyes, and the space between the outer corners of
        the eyes to the edges of the face. This proportion is expressed as
        <b>1:1:1:1:1. (20%:20%:20%:20%:20%)</b>
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face1/5rule.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'face1_5Rule',
    ratio: '15%, 25%, 20%, 25%, 15%',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_1_5_rule.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_1_5rule.jpg'),
    image_portrait_ratio_position: {
      width: '50%',
      height: '65%',
      top: '65px',
      left: '90px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_1_5rule.jpg'),
    image_landscape_ratio_position: {
      width: '28%',
      height: '60%',
      top: '60px',
      left: '173px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_1_5face.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face.aspect.ratio">
        Face Aspect Ratio
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face.aspect.ratio.desc1">
        The golden ratio of the Face Aspect Ratio is the relationship between
        the height of the face and its width, ideally following the golden ratio
        of <b>1:1.46</b>, creating a balanced and aesthetically pleasing
        appearance.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.face.aspect.ratio.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.{' '}
      </Trans>
    ),
    value: 'faceAspectRatio',
    ratio: '1:1.46',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_faceratio.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_face_ratio.jpg'),
    image_portrait_ratio_position: {
      width: '50%',
      height: '60%',
      top: '75px',
      left: '90px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_faceratio.jpg'),
    image_landscape_ratio_position: {
      width: '28%',
      height: '60%',
      top: '60px',
      left: '170px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_arface.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.eye.height.to.eyebrow.distance">
        Eye Height to Eyebrow Distance
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.eye.height.to.eyebrow.distance.desc1">
        The golden ratio of the Eye Height to Eye to Eyebrow Distance is the
        vertical distance from the top of the upper eyelid to the highest point
        of the eyebrow, ideally following the golden ratio when compared to the
        eye height. This ratio creates a harmonious balance between the eyes and
        the brows, following the
        <b>1:1.618</b> proportion.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.eye.height.to.eyebrow.distance.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'eyeHeightToEyebrowDistance',
    ratio: '1:1.618',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_eyeheighttobrow.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_eye_to_brows.jpg'),
    image_portrait_ratio_position: {
      width: '65%',
      height: '38%',
      top: '120px',
      left: '65px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_eye.jpg'),
    image_landscape_ratio_position: {
      width: '50%',
      height: '50%',
      top: '75px',
      left: '120px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_eyeheight.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.aspect.ratio">
        Nose Aspect Ratio
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.aspect.ratio.desc1">
        The golden ratio of the Nose Aspect Ratio is the relationship between
        the width of the nose and its height, ideally following the golden ratio
        of <b>1:1.618</b>.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.aspect.ratio.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'noseAspectRatio',
    ratio: '1:1.618',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_noseratio.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_nose_ratio.jpg'),
    image_portrait_ratio_position: {
      width: '65%',
      height: '38%',
      top: '120px',
      left: '65px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_noseaspect.jpg'),
    image_landscape_ratio_position: {
      width: '50%',
      height: '50%',
      top: '75px',
      left: '120px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_arnose.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.width.to.mouth.width">
        Nose Width to Mouth Width
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.width.to.mouth.width.desc1">
        The golden ratio of the Nose Width Ratio to Mouth is the relationship
        between the width of the nose and width of the mouth, ideally following
        the golden ratio of
        <b>1:1.618</b>, creating a balanced and aesthetically pleasing
        appearance.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.width.to.mouth.width.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'noseWidthToMouthWidth',
    ratio: '1:1.618',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_nose_mouth_width.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_nose_mouth_width.jpg'),
    image_portrait_ratio_position: {
      width: '65%',
      height: '38%',
      top: '120px',
      left: '65px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_mouth_nose.jpg'),
    image_landscape_ratio_position: {
      width: '50%',
      height: '50%',
      top: '75px',
      left: '120px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_noselip_width.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.to.lip.to.chin">
        Nose to Lip to Chin
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.to.lip.to.chin.desc1">
        The golden ratio of the Nose to Lip to Chin is a proportion where the
        distance from the base of the nose to the center of the lip is 1, and
        the distance from the center of the lip to the chin is 1.618. This ratio
        creates a balanced and harmonious lower face, following the principles
        of facial symmetry.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.nose.to.lip.to.chin.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'noseToLipToChin',
    ratio: '1:1.618',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_nose_lip_chin.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_nose_lip_chin.jpg'),
    image_portrait_ratio_position: {
      width: '65%',
      height: '38%',
      top: '120px',
      left: '65px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_nosetoliptochin.jpg'),
    image_landscape_ratio_position: {
      width: '50%',
      height: '50%',
      top: '70px',
      left: '120px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_nosetochin.jpg'),
  },
  {
    label: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.upper.lip.to.lower.lip">
        Upper Lip to Lower Lip
      </Trans>
    ),
    desc1: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.upper.lip.to.lower.lip.desc1">
        The golden ratio of the Upper Lip to the Lower Lip suggests that the
        height of the lower lip should be 1.618 times the height of the upper
        lip. This proportion creates a balanced and aesthetically pleasing look,
        with the lower lip being slightly fuller than the upper lip.
      </Trans>
    ),
    desc2: (
      <Trans i18nKey="u.c.globals.simulation.faceassessment.upper.lip.to.lower.lip.desc2">
        Disclaimer: The “Golden Ratio” is one approach to evaluating facial
        aesthetics, reflecting ideals primarily rooted in Western standards. It
        may not resonate with all cultural or individual perceptions of beauty.
        Use this as a guide, not an absolute standard, and consult a
        professional for personalized advice.
      </Trans>
    ),
    value: 'upperLipToLowerLip',
    ratio: '1:1.618',
    isPremium: false,
    icon: require('../assets/images/skincare/face_assessment/ico_simulation_uppper_lower_lips.png'),
    image_portrait: require('../assets/images/skincare/face_assessment/portrait/img_faceassessmenton_upper_lower_lip.jpg'),
    image_portrait_ratio_position: {
      width: '65%',
      height: '38%',
      top: '120px',
      left: '65px',
    },
    image_landscape: require('../assets/images/skincare/face_assessment/landscape/landscape_lips.jpg'),
    image_landscape_ratio_position: {
      width: '50%',
      height: '50%',
      top: '55px',
      left: '120px',
    },
    image_info: require('../assets/images/skincare/face_assessment/img_simulation_assessment_info_arlips.jpg'),
  },
];

const combineTreatments = (options, isPremiumPlan, orderBy = []) => {
  if (orderBy.length > 0) {
    let result = [];
    orderBy.forEach(type => {
      result = result.concat(_get(options, type));
    });
    return result;
  }
  return isPremiumPlan
    ? options.face
        .concat(options.eyebrows)
        .concat(options.eyes)
        .concat(options.lips)
        .concat(options.nose)
        .concat(options.skin)
    : options.face.concat(options.eyebrows).concat(options.lips);
};

const getDetectionLanguages = () => {
  return [
    {label: 'English', value: 'en'},
    {label: 'Français', value: 'fr'},
    {label: '日本語', value: 'ja'},
    {label: '繁體中文', value: 'zh-Hant'},
    {label: '简体中文', value: 'zh-Hans'},
    {label: '한국어', value: 'ko'},
    {label: 'Deutsch', value: 'de'},
    {label: 'Español', value: 'es'},
    {label: 'Italiano', value: 'it'},
    {label: 'Português', value: 'pt'},
    {label: 'العربية', value: 'ar'},
  ];
};

const getCurrencyOptions = () => {
  const supportedCurrencies = [
    'AUD',
    'BRL',
    'CAD',
    'CNY',
    'COP',
    'CRC',
    'CZK',
    'DKK',
    'EUR',
    'GBP',
    'GTQ',
    'HKD',
    'HUF',
    'ILS',
    'INR',
    'JPY',
    'KRW',
    'LBP',
    'MNT',
    'MXN',
    'MYR',
    'NOK',
    'NTD',
    'PLN',
    'RON',
    'RSD',
    'RUB',
    'SGD',
    'TRY',
    'USD',
    'UYU',
  ];

  return supportedCurrencies.map(currency => ({
    label: `${planUtils.dollarSymbols[currency]} ${currency}`,
    value: currency,
  }));
};

const getHtmlLanguages = {
  enu: 'en',
  fra: 'fr',
  jpn: 'ja',
  cht: 'zh_TW',
  chs: 'zh_CN',
  kor: 'ko',
  deu: 'de',
  esp: 'es',
  ita: 'it',
  ptb: 'pt',
  ara: 'ar',
};

const skincareSkuTypes = [
  {
    value: 'ACNE_BLEMISH_TREATMENTS',
    label: 'Acne & Blemish Treatments',
  },
  {
    value: 'BODY_CARE',
    label: 'Body Care',
  },
  {
    value: 'CLEANSERS_TONES',
    label: 'Cleansers & Toners',
  },
  {
    value: 'DAY_CARE',
    label: 'Day Care',
  },
  {
    value: 'EYE_LIPCARE',
    label: 'Eye & Lip Care',
  },
  {
    value: 'MOISTURIZERS_TREATMENTS',
    label: 'Moisturizers Treatments',
  },
  {
    value: 'NIGHT_CARE',
    label: 'Night Care',
  },
  {
    value: 'SKIN_CARE_SET',
    label: 'Skin Care Set',
  },
  {
    value: 'SUN_CARE',
    label: 'Sun Care',
  },
  {
    value: 'TOOLS_ACCESSRIES',
    label: 'Tools & Accessories',
  },
  {
    value: 'ROUTINE',
    label: 'Routine',
  },
  {
    value: 'AMPLIFIER',
    label: 'Amplifier',
  },
  {
    value: 'MASK',
    label: 'Mask',
  },
  {
    value: 'SERUM',
    label: 'Serum',
  },
  {
    value: 'OTHERS',
    label: 'Specialty',
  },
  {
    value: 'TREATMENT',
    label: 'Treatment',
  },
  {
    value: 'ESSENCE',
    label: 'Essence',
  },
  {
    value: 'SMB_PRODUCT',
    label: 'SMB Product',
  },
  {
    value: 'SMB_ROUTINE',
    label: 'SMB routine',
  },
  {
    value: 'SMB_TREATMENT',
    label: 'SMB Treatment',
  },
];

const skinCareScoreType = [
  {
    value: 'wrinkle',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkle',
      'Wrinkle'
    ),
    i18n: 'wrinkle',
  },
  {
    value: 'spot',
    label: i18n.t('p.g.c.changeplan.info.essential.spot', 'Spot'),
    i18n: 'spots',
  },
  {
    value: 'texture',
    label: i18n.t(
      'p.g.c.changeplan.info.essential.skincare.texture',
      'Texture'
    ),
    i18n: 'texture',
  },
  {
    value: 'dark_circle',
    label: i18n.t(
      'u.c.globals.simulation.treatment.type.dark.circle',
      'Dark Circle'
    ),
    i18n: 'dark.circle',
  },
  {
    value: 'redness',
    label: i18n.t(
      'p.g.c.changeplan.info.essential.skincare.redness',
      'Redness'
    ),
    i18n: 'redness',
  },
  {
    value: 'oiliness',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.oiliness',
      'Oiliness'
    ),
    i18n: 'oiliness',
  },
  {
    value: 'moisture',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.moisture',
      'Moisture'
    ),
    i18n: 'moisture',
  },
  {
    value: 'eye_bag',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.eyebag',
      'Eye Bag'
    ),
    i18n: 'eyebag',
  },
  {
    value: 'radiance',
    label: i18n.t('p.s.c.s.preview.radiance', 'Radiance'),
    i18n: 'radiance',
  },
  {value: 'acne', label: i18n.t('p.s.c.s.preview.acne', 'Acne'), i18n: 'acne'},
  {
    value: 'droopy_upper_eyelid',
    label: i18n.t('p.s.c.s.preview.droopy.upper.eyelid', 'Droopy upper eyelid'),
    i18n: 'droopy.upper.eyelid',
  },
  {
    value: 'droopy_lower_eyelid',
    label: i18n.t('p.s.c.s.preview.droopy.lower.eyelid', 'Droopy lower eyelid'),
    i18n: 'droopy.lower.eyelid',
  },
  {
    value: 'firmness',
    label: i18n.t('p.s.c.s.preview.firmness', 'Firmness'),
    i18n: 'firmness',
  },
  {
    value: 'pore',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.pore', 'Pore'),
    i18n: 'pore',
  },
];

const skinCareHdScoreType = [
  {
    value: 'hd_wrinkle',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkle',
      'Wrinkle'
    ),
    i18n: 'wrinkle',
    isShowOptions: true,
    options: [
      {
        value: 'hd_wrinkle',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.full.face.abbr',
          'Full Face'
        ),
        i18n: 'wrinkles.full.face.abbr',
      },
      {
        value: 'hd_wrinkle_crowfeet',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.crow.feet.abbr',
          "Crow's Feet"
        ),
        i18n: 'wrinkles.crow.feet.abbr',
      },
      {
        value: 'hd_wrinkle_nasolabial',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.nasolabial.abbr',
          'Nasolabial Folds'
        ),
        i18n: 'wrinkles.nasolabial.abbr',
      },
      {
        value: 'hd_wrinkle_periocular',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.periocular.abbr',
          'Periocular Lines'
        ),
        i18n: 'wrinkles.periocular.abbr',
      },
      {
        value: 'hd_wrinkle_glabellar',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.glabellar.abbr',
          'Glabellar Lines'
        ),
        i18n: 'wrinkles.glabellar.abbr',
      },
      {
        value: 'hd_wrinkle_forehead',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.forehead.abbr',
          'Forehead Lines'
        ),
        i18n: 'wrinkles.forehead.abbr',
      },
      {
        value: 'hd_wrinkle_marionette',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.marionette.abbr',
          'Marionette Lines'
        ),
        i18n: 'wrinkles.marionette.abbr',
      },
    ],
  },
  {
    value: 'hd_teartrough',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.tear.trough',
      'Tear Trough'
    ),
    i18n: 'tear.trough',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_spot',
    label: i18n.t('p.g.c.changeplan.info.essential.spot', 'Spot'),
    i18n: 'spots',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_texture',
    label: i18n.t(
      'p.g.c.changeplan.info.essential.skincare.texture',
      'Texture'
    ),
    i18n: 'texture',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_dark_circle',
    label: i18n.t(
      'u.c.globals.simulation.treatment.type.dark.circle',
      'Dark Circle'
    ),
    i18n: 'dark.circle',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_redness',
    label: i18n.t(
      'p.g.c.changeplan.info.essential.skincare.redness',
      'Redness'
    ),
    i18n: 'redness',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_oiliness',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.oiliness',
      'Oiliness'
    ),
    i18n: 'oiliness',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_moisture',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.moisture',
      'Moisture'
    ),
    i18n: 'moisture',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_eye_bag',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.eyebag',
      'Eye Bag'
    ),
    i18n: 'eyebag',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_radiance',
    label: i18n.t('p.s.c.s.preview.radiance', 'Radiance'),
    i18n: 'radiance',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_acne',
    label: i18n.t('p.s.c.s.preview.acne', 'Acne'),
    i18n: 'acne',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_droopy_upper_eyelid',
    label: i18n.t('p.s.c.s.preview.droopy.upper.eyelid', 'Droopy upper eyelid'),
    i18n: 'droopy.upper.eyelid',
  },
  {
    value: 'hd_droopy_lower_eyelid',
    label: i18n.t('p.s.c.s.preview.droopy.lower.eyelid', 'Droopy lower eyelid'),
    i18n: 'droopy.lower.eyelid',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_firmness',
    label: i18n.t('p.s.c.s.preview.firmness', 'Firmness'),
    i18n: 'firmness',
    isShowOptions: false,
    options: [],
  },
  {
    value: 'hd_pore',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.pore', 'Pore'),
    i18n: 'pore',
    isShowOptions: true,
    options: [
      {
        value: 'hd_pore',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.pore.full.face.abbr',
          'Full Face'
        ),
        i18n: 'pore.full.face.abbr',
      },
      {
        value: 'hd_pore_forehead',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.pore.forehead.abbr',
          'Forehead'
        ),
        i18n: 'pore.forehead.abbr',
      },
      {
        value: 'hd_pore_nose',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.nose.abbr',
          'Nose'
        ),
        i18n: 'nose.abbr',
      },
      {
        value: 'hd_pore_cheek',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.cheek.abbr',
          'Cheeks'
        ),
        i18n: 'cheek.abbr',
      },
    ],
  },
];

const getSkinCareFlatScoreType = (isHd = false, isSubOption = false) => {
  if (isHd && isSubOption) {
    return skinCareHdScoreType.flatMap(c => {
      if (isSubOption && _get(c, 'options', []).length > 0) {
        return c.options.map(option => ({
          label: option.label,
          value: option.value,
        }));
      }
      return {label: c.label, value: c.value};
    });
  } else if (isHd) {
    return skinCareHdScoreType;
  }
  return skinCareScoreType;
};

const detectionType = [
  {
    label: (
      <Trans i18nKey="u.c.globals.product.types.product.recommendation">
        Product recommendation
      </Trans>
    ),
    value: 'recommendation',
  },
  {
    label: (
      <Trans i18nKey="u.c.skincare.detection.type.description">
        Detect description
      </Trans>
    ),
    value: 'description',
  },
  {
    label: <Trans i18nKey="u.c.skincare.detection.none">None</Trans>,
    value: 'none',
  },
];

const displayOrder = [
  {
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.display.order.manual">
        Manual Drag & Drop
      </Trans>
    ),
    value: 'manual',
  },
  {
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.display.order.asc">
        Score: Low to High
      </Trans>
    ),
    value: 'asc',
  },
  {
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.category.display.order.desc">
        Score: High to Low
      </Trans>
    ),
    value: 'desc',
  },
];

const updateArrayStatus = (checkArray, originalArrays) => {
  const checkSet = new Set(checkArray);
  const sortByCheckArray = (a, b) => {
    const indexA = checkArray.indexOf(a.value);
    const indexB = checkArray.indexOf(b.value);

    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  };
  // Map and sort sub-options
  const updatedArray = originalArrays.map(item => {
    const isChecked = checkSet.has(item.value);
    item.disabled = !isChecked;
    if (!item.options || !Array.isArray(item.options)) {
      return item;
    }

    const updatedOptions = item.options
      .map(option => ({
        ...option,
        disabled: !checkSet.has(option.value),
      }))
      .sort(sortByCheckArray);

    return {
      ...item,
      disabled: !isChecked,
      options: updatedOptions,
    };
  });
  // Map and sort options
  return updatedArray.sort(sortByCheckArray);
};

const mappingDisable = (array, mappingArray, isSupportSubOptions = false) => {
  if (isSupportSubOptions) {
    return updateArrayStatus(array, mappingArray);
  }

  const enabled = [];
  const map = mappingArray.reduce((map, ca) => {
    map[ca.value] = ca;
    return map;
  }, {});

  array.forEach((c, i) => {
    enabled[i] = {..._cloneDeep(map[c]), disabled: false};
    delete map[c];
  });

  let disable = [];
  disable = Object.values(map).map(c => ({
    ...c,
    disabled: true,
    options: c.options
      ? c.options.map(option => ({
          ...option,
          disabled: true,
        }))
      : [],
  }));

  return [...enabled, ...disable].filter(Boolean);
};

const arrayMapping = (array, isSupportSubOptions = false) => {
  if (isSupportSubOptions) {
    const result = [];

    array.forEach(item => {
      if (!item.disabled && _get(item, 'options', []).length > 0) {
        item.options.forEach(option => {
          if (!option.disabled) {
            result.push(option.value);
          }
        });
      } else if (!item.disabled && _get(item, 'options', []).length === 0) {
        result.push(item.value);
      }
    });

    return result;
  }
  let data = array.filter(r => r.disabled === false);
  let newData = [];
  data.forEach(c => {
    newData.push(c.value);
  });
  return newData;
};

const arrayMappingValue = array => {
  let data = array.filter(r => r.disabled === false);
  let newData = [];
  data.forEach(c => {
    newData.push({value: c.value});
  });
  return newData;
};

function transformSubOptionToOption(data) {
  const result = [];
  data.forEach(item => {
    if (_get(item, 'options', []).length > 0) {
      result.push(...item.options);
    } else {
      result.push(item);
    }
  });

  return result;
}

const getCategory = async (token, customerId, type) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('types', type);
  const res = await skincareProDao.getCategoryList(tmp);

  if (res.categories) {
    return res.categories.map(item => ({
      label: item.name,
      value: item.id,
    }));
  }
};

const generationStatus = [
  {
    value: 'success',
    label: i18n.t(
      'u.c.skin.recommendation.ai.rule.generation.status.success',
      'Rule Updated'
    ),
    class: 'text-success',
  },
  {
    value: 'fail',
    label: i18n.t(
      'u.c.skin.recommendation.ai.rule.generation.status.fail',
      ' Generation Failed'
    ),
    class: 'text-danger',
  },
  {
    value: 'none',
    label: '-',
    class: '',
  },
];

const skinAiRuleIndicators = [
  {
    value: 'wrinkle',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.wrinkles',
      'Wrinkles'
    ),
  },
  {
    value: 'pore',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.pore', 'Pore'),
  },
  {
    value: 'spot',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.spots',
      'Spots'
    ),
  },
  {
    value: 'texture',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.texture',
      'Texture'
    ),
  },
  {
    value: 'dark_circle',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.dark.circle',
      'Dark Circles'
    ),
  },
  {
    value: 'redness',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.redness',
      'Redness'
    ),
  },
  {
    value: 'oiliness',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.oiliness',
      'Oiliness'
    ),
  },
  {
    value: 'moisture',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.moisture',
      'Moisture'
    ),
  },
  {
    value: 'eye_bag',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.eyebag',
      'Eye bag'
    ),
  },
  {
    value: 'radiance',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.radiance',
      'Radiance'
    ),
  },
  {
    value: 'acne',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.acne', 'Acne'),
  },
  {
    value: 'firmness',
    label: i18n.t('p.s.c.s.preview.firmness', 'Firmness'),
  },
  {
    value: 'droopy_upper_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.upper.eyelid',
      'Droopy Upper Eyelid'
    ),
  },
  {
    value: 'droopy_lower_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.lower.eyelid',
      'Droopy Lower Eyelid'
    ),
  },
];

const skinHdAiRuleIndicators = [
  {
    value: 'hd_wrinkle',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.wrinkles',
      'Wrinkles'
    ),
    isNew: false,
    options: [
      {
        value: 'hd_wrinkle',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.full.face.abbr',
          'Full Face'
        ),
        order: 0,
        isRequired: true,
      },
      {
        value: 'hd_wrinkle_forehead',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.forehead.abbr',
          'Forehead Lines'
        ),
        order: 1,
        isRequired: false,
      },
      {
        value: 'hd_wrinkle_glabellar',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.glabellar.abbr',
          'Glabellar Lines'
        ),
        order: 2,
        isRequired: false,
      },
      {
        value: 'hd_wrinkle_periocular',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.periocular.abbr',
          'Periocular Lines'
        ),
        order: 3,
        isRequired: false,
      },
      {
        value: 'hd_wrinkle_crowfeet',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.crow.feet.abbr',
          "Crow's Feet"
        ),
        order: 4,
        isRequired: false,
      },
      {
        value: 'hd_wrinkle_nasolabial',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.nasolabial.abbr',
          'Nasolabial Folds'
        ),
        order: 5,
        isRequired: false,
      },
      {
        value: 'hd_wrinkle_marionette',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.marionette.abbr',
          'Marionette Lines'
        ),
        order: 6,
        isRequired: false,
      },
    ],
  },
  {
    value: 'hd_pore',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.pore', 'Pore'),
    isNew: false,
    options: [
      {
        value: 'hd_pore',
        label: i18n.t(
          'u.c.skin.detection.categories.i.skincare.pore.full.face.abbr',
          'Full Face'
        ),
        order: 0,
        isRequired: true,
      },
      {
        value: 'hd_pore_forehead',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.pore.forehead.abbr',
          'Forehead'
        ),
        order: 1,
        isRequired: false,
      },
      {
        value: 'hd_pore_nose',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.nose.abbr',
          'Nose'
        ),
        order: 2,
        isRequired: false,
      },
      {
        value: 'hd_pore_cheek',
        label: i18n.t(
          'p.s.uiconfiguration.skincaredetection.detection.description.content.cheek.abbr',
          'Cheeks'
        ),
        order: 3,
        isRequired: false,
      },
    ],
  },
  {
    value: 'hd_spot',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.spots',
      'Spots'
    ),
    isNew: false,
  },
  {
    value: 'hd_texture',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.texture',
      'Texture'
    ),
    isNew: false,
  },
  {
    value: 'hd_dark_circle',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.dark.circle',
      'Dark Circles'
    ),
    isNew: false,
  },
  {
    value: 'hd_redness',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.redness',
      'Redness'
    ),
    isNew: false,
  },
  {
    value: 'hd_oiliness',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.oiliness',
      'Oiliness'
    ),
    isNew: false,
  },
  {
    value: 'hd_moisture',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.moisture',
      'Moisture'
    ),
    isNew: false,
  },
  {
    value: 'hd_eye_bag',
    label: i18n.t(
      'u.c.skin.detection.categories.i.u.s.addoreditconfig.eyebag',
      'Eye bag'
    ),
    isNew: false,
  },
  {
    value: 'hd_radiance',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.radiance',
      'Radiance'
    ),
    isNew: false,
  },
  {
    value: 'hd_acne',
    label: i18n.t('u.c.skin.detection.categories.i.skincare.acne', 'Acne'),
    isNew: false,
  },
  {
    value: 'hd_firmness',
    label: i18n.t('p.s.c.s.preview.firmness', 'Firmness'),
    isNew: false,
  },
  {
    value: 'hd_droopy_upper_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.upper.eyelid',
      'Droopy Upper Eyelid'
    ),
    isNew: false,
  },
  {
    value: 'hd_droopy_lower_eyelid',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.droopy.lower.eyelid',
      'Droopy Lower Eyelid'
    ),
    isNew: false,
  },
  {
    value: 'hd_teartrough',
    label: i18n.t(
      'u.c.skin.detection.categories.i.skincare.tear.trough',
      'Tear Trough'
    ),
    isNew: true,
  },
];

const skinTypeAiRuleIndicators = [
  {
    value: 'skin_type',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.skintype',
      'Skin Type'
    ),
    isNew: true,
    options: skinDetectionCategories
      .getSkinDetectionFacialArea()
      .map(({value_v2_hd, label}, index) => ({
        value: value_v2_hd,
        label,
        order: index,
        isRequired: index === 0,
      })),
  },
  {
    value: 'sensitive',
    label: i18n.t(
      'p.s.uiconfiguration.skincaredetection.detection.description.content.normal.skinsensitivity',
      'Skin Sensitivity'
    ),
    isNew: true,
    options: skinDetectionCategories
      .getSkinSensitivityFacialArea()
      .map(({value_v2_hd, label}, index) => ({
        value: value_v2_hd,
        label,
        order: index,
        isRequired: index === 0,
      })),
  },
];

const getTemplateLayout = (
  token,
  customerId,
  pageType = 'SmbLandingPage',
  version = 1
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('pageType', pageType);
  tmp.append('version', version);
  return skincareProDao.getTemplateLayout(tmp);
};

const processV1toV2Data = async (token, customerId, brandInfo) => {
  const landingV1 = await getTemplate(
    token,
    customerId,
    _get(brandInfo, 'landingPageRvId'),
    'LandingPage'
  ).then(res => {
    if (res && res.metaDataJson) {
      return JSON.parse(res.metaDataJson);
    }
  });
  const resultV1 = await getTemplate(
    token,
    customerId,
    _get(brandInfo, 'resultPageRvId'),
    'ResultHomePage'
  ).then(res => {
    if (res && res.metaDataJson) {
      return JSON.parse(res.metaDataJson);
    }
  });
  const landingConfigJson = v1tov2Utils.parserLandingDataConfig(landingV1);
  const landingMetaDataJson = v1tov2Utils.parserLandingDataMeta();
  const resultConfigJson = v1tov2Utils.parserResultDataConfig(resultV1);
  const resultMetaDataJson = v1tov2Utils.parserResultDataMeta(resultV1);
  const commonSettingConfigJson = v1tov2Utils.parserCommonDataConfig(landingV1);
  const commonSettingMetaDataJson = v1tov2Utils.parserCommonDataMeta(landingV1);
  return {
    landingConfigJson,
    landingMetaDataJson,
    resultConfigJson,
    resultMetaDataJson,
    commonSettingConfigJson,
    commonSettingMetaDataJson,
  };
};

const migrateTemplateV2 = (
  token,
  customerId,
  landingConfigJson = '',
  landingMetaDataJson = '',
  resultConfigJson = '',
  resultMetaDataJson = '',
  commonSettingConfigJson = '',
  commonSettingMetaDataJson = ''
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('landingConfigJson', JSON.stringify(landingConfigJson));
  tmp.append('landingMetaDataJson', JSON.stringify(landingMetaDataJson));
  tmp.append('resultConfigJson', JSON.stringify(resultConfigJson));
  tmp.append('resultMetaDataJson', JSON.stringify(resultMetaDataJson));
  tmp.append(
    'commonSettingConfigJson',
    JSON.stringify(commonSettingConfigJson)
  );
  tmp.append(
    'commonSettingMetaDataJson',
    JSON.stringify(commonSettingMetaDataJson)
  );
  return skincareProDao.migrateTemplateV2(tmp);
};

const getTemplate = (token, customerId, revisionId, templateType) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('revisionId', revisionId);
  if (!_isEmpty(templateType)) {
    tmp.append('templateType', templateType);
  }
  return skincareProDao.getTemplate(tmp);
};

const updateTemplate = (
  token,
  customerId,
  templateId,
  templateType,
  metaDataJson,
  fileId,
  configJson
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('pageId', templateId.match(/\d+/));
  if (!_isEmpty(templateType)) {
    tmp.append('templateType', templateType);
  }
  tmp.append('metaDataJson', JSON.stringify(metaDataJson));
  if (!_isEmpty(fileId)) {
    tmp.append('configFileId', fileId);
  }
  if (!_isEmpty(configJson)) {
    tmp.append('configJson', JSON.stringify(configJson));
  }
  return skincareProDao.updateTemplate(tmp);
};

const getBrandId = (token, customerId) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  return skincareProDao.getBrandIdAndTemplate(tmp);
};

const publishConfig = (token, customerId, brandId) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('brandId', brandId);
  return skincareProDao.publishBrandId(tmp);
};

const getProductList = async (
  token,
  customerId,
  types,
  service,
  limit = 99999,
  forPicker = false
) => {
  const tmp = new FormData();
  tmp.append('token', token);
  tmp.append('customerId', customerId);
  tmp.append('types', JSON.stringify(types));
  tmp.append('service', service);
  tmp.append('limit', limit);
  tmp.append('forPicker', forPicker);
  return await skincareProDao.getGenericList(tmp);
};

const convertNumInSurveyRule = ({['in']: values}) => ({
  in: values.map(item =>
    typeof item === 'string' && !isNaN(item) ? Number(item) : item
  ),
});

const processRuleData = (data = [], setting) => {
  let productIds = [];
  const mergeRules = data.map(caseItem => {
    const indicatorPool = [];
    let copyConditions = _cloneDeep(caseItem[0]);
    // add dark circle v2 & indicator pool for recommendation products
    caseItem[0].forEach((c, index) => {
      const operator = Object.keys(c)[0];
      const ruleList = [];
      _get(c, `[${operator}]`, []).forEach(rule => {
        const ruleOperator = Object.keys(rule)[0];
        if (ruleOperator === 'in') {
          indicatorPool.push('survey');
          const parserSurveyRule = convertNumInSurveyRule(rule);
          ruleList.push(parserSurveyRule);
        } else {
          const indicator = _get(rule, `[${ruleOperator}][0].var`);
          indicatorPool.push(indicator);
          if (indicator === 'dark_circle') {
            let copyRule = _cloneDeep(rule);
            copyRule[ruleOperator][0].var = 'dark_circle_v2';
            ruleList.push({or: [rule, copyRule]});
            indicatorPool.push('dark_circle_v2');
          } else {
            if (
              Object.keys(rule)[0] === '<<' ||
              Object.keys(rule)[0] === '<=<'
            ) {
              const o = Object.keys(rule)[0] === '<<' ? '<' : '<=';
              ruleList.push({[`${o}`]: _get(rule, `[${ruleOperator}]`)});
            } else {
              ruleList.push(rule);
            }
          }
        }
      });
      copyConditions[index][operator] = ruleList;
    });

    let conditions = {};
    conditions[caseItem[2]] = copyConditions;
    const products = [];
    caseItem[1].forEach(p => {
      products.push({addProduct: [p.addProduct[0].id, _uniq(indicatorPool)]});
      productIds.push(p.addProduct[0].id);
    });
    return {case: [{caseName: caseItem[3]}, conditions, products]};
  });

  const parseRule = _get(setting, 'rule.attrs')
    ? {
        ...setting.rule,
        jsonLogicV2: JSON.stringify({merge: mergeRules}),
      }
    : {
        jsonLogicV2: JSON.stringify({merge: mergeRules}),
      };

  return {
    ...setting,
    productIds: JSON.stringify(_uniq(productIds)),
    rule: parseRule,
  };
};

const removeSurveyCases = data => {
  if (Array.isArray(data)) {
    return data.map(removeSurveyCases).filter(Boolean);
  } else if (typeof data === 'object' && data !== null) {
    if (data.hasOwnProperty('in')) {
      return null; // Remove Survey condition
    }
    return Object.fromEntries(
      Object.entries(data)
        .map(([key, value]) => [key, removeSurveyCases(value)])
        .filter(([, value]) => value !== null)
    );
  }
  return data;
};

const removeEmptyCase = obj => {
  const data = _get(obj, 'merge', []);
  const res = [];
  for (let ruleCase of data) {
    if (
      _get(ruleCase, 'case[1].or[0].and', []).length !== 0 ||
      _get(ruleCase, 'case[1].or[0].or', []).length !== 0
    ) {
      res.push(ruleCase);
    }
  }
  return {merge: res};
};

//for handle 2 operators (< : between and "<")
function renameKeys(obj) {
  const keyValues = Object.entries(obj).map(([key, value]) => {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      value = renameKeys(value);
    }
    if (key === '<<') {
      return ['<', value];
    }
    if (key === '<=<') {
      return ['<=', value];
    }
    return [key, value];
  });
  return Object.fromEntries(keyValues);
}

const processAiRuleData = rule => {
  if (_isEmpty(rule)) {
    return rule;
  }
  const operator = Object.keys(rule.if[0])[0];
  let r = [];
  if (rule.if[0][`${operator}`].length > 0) {
    rule.if[0][`${operator}`].forEach(rr => {
      const o = Object.keys(rr)[0];
      r.push({[`${o}`]: Object.values(renameKeys(rr[`${o}`]))});
    });
  }
  return {
    if: [{[`${operator}`]: r}, rule.if[1]],
  };
};

const descriptionContent = (language, isHd = false, isPremium = false) => {
  if (isHd) {
    return [
      {
        value: 'skin_age',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skin.age">
            Skin Age
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.skin_age`,
        isPremium: false,
        isConcern: false,
      },
      {
        value: 'skin_health',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skin.health">
            Skin Health
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.skin_health`,
        isPremium: false,
        isConcern: false,
      },
      {
        value: 'normal_non_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.normal.nonsensitive">
            Skin Type - Normal
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.normal_non_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'oily_non_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.oily.nonsensitive">
            Skin Type - Oily
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.oily_non_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'dry_non_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.dry.nonsensitive">
            Skin Type - Dry
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.dry_non_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'combination_non_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.combination.nonsensitive">
            Skin Type - Combination
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.combination_non_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'normal_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.normal.sensitive">
            Skin Type - Sensitive
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.normal_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'dry_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.dry.sensitive">
            Skin Type - Dry & Sensitive
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.dry_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'oily_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.oily.sensitive">
            Skin Type - Oily & Sensitive
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.oily_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'combination_sensitive',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype.combination.sensitive">
            Skin Type - Combination & Sensitive
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.combination_sensitive`,
        isPremium: true,
        isConcern: false,
      },
      {
        value: 'hd_spot',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.spots">
            Spots
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_spot`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_redness',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.redness">
            Redness
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_redness`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_moisture',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.moisture">
            Moisture
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_moisture`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_oiliness',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.oiliness">
            Oiliness
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_oiliness`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle',
        label: isPremium ? (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.full.face">
            Wrinkles - Full Face
          </Trans>
        ) : (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkle">
            Wrinkles
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_wrinkle`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_forehead',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.forehead">
            Wrinkles - Forehead Lines
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_forehead`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_glabellar',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.glabellar">
            Wrinkles - Glabellar Lines
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_glabellar`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_periocular',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.periocular">
            Wrinkles - Periocular Lines
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_periocular`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_crowfeet',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.crow.feet">
            Wrinkles - Crow's Feet
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_crowfeet`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_nasolabial',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.nasolabial">
            Wrinkles - Nasolabial Folds
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_nasolabial`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_wrinkle_marionette',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.marionette">
            Wrinkles - Marionette Lines
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_wrinkle_marionette`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_texture',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.texture">
            Texture
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_texture`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_eye_bag',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.eyebag">
            Eyebag
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_eye_bag`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_firmness',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.firmness">
            Firmness
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_firmness`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_droopy_upper_eyelid',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.droopy.upper.eyelid">
            Droopy Upper Eyelid
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_droopy_upper_eyelid`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_droopy_lower_eyelid',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.droopy.lower.eyelid">
            Droopy Lower Eyelid
          </Trans>
        ),
        key: `detectionDescriptionContent.${
          language.value
        }.hd_droopy_lower_eyelid`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_acne',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.acne">
            Acne
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_acne`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_pore',
        label: (
          <Trans i18nKey="u.c.skin.detection.categories.i.skincare.pore.full.face">
            Pores - Full Face
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_pore`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_pore_forehead',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.pore.forehead">
            Pores - Forehead
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_pore_forehead`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_pore_nose',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.nose">
            Pores - Nose
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_pore_nose`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_pore_cheek',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.cheek">
            Pores - Cheeks
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_pore_cheek`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_dark_circle',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.dark.circle">
            Dark Circles
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_dark_circle`,
        isPremium: false,
        isConcern: true,
      },
      {
        value: 'hd_radiance',
        label: (
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.radiance">
            Radiance
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_radiance`,
        isPremium: true,
        isConcern: true,
      },
      {
        value: 'hd_teartrough',
        label: (
          <Trans i18nKey="u.c.skin.detection.categories.i.skincare.tear.trough">
            Tear Trough
          </Trans>
        ),
        key: `detectionDescriptionContent.${language.value}.hd_teartrough`,
        isPremium: true,
        isConcern: true,
      },
    ];
  }
  return [
    {
      value: 'skin_age',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skin.age">
          Skin Age
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.skin_age`,
      isPremium: false,
      isConcern: false,
    },
    {
      value: 'skin_health',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skin.health">
          Skin Health
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.skin_health`,
      isPremium: false,
      isConcern: false,
    },
    {
      value: 'age_spot',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.spots">
          Spots
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.age_spot`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'redness',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.redness">
          Redness
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.redness`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'moisture',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.moisture">
          Moisture
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.moisture`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'oiliness',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.oiliness">
          Oiliness
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.oiliness`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'wrinkle',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkle">
          Wrinkles
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.wrinkle`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'texture',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.texture">
          Texture
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.texture`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'eye_bag',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.eyebag">
          Eyebag
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.eye_bag`,
      isPremium: false,
      isConcern: true,
    },
    {
      value: 'firmness',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.firmness">
          Firmness
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.firmness`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'droopy_upper_eyelid',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.droopy.upper.eyelid">
          Droopy Upper Eyelid
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.droopy_upper_eyelid`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'droopy_lower_eyelid',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.droopy.lower.eyelid">
          Droopy Lower Eyelid
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.droopy_lower_eyelid`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'radiance',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.radiance">
          Radiance
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.radiance`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'acne',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.acne">
          Acne
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.acne`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'pore',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.pore">
          Pore
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.pore`,
      isPremium: true,
      isConcern: true,
    },
    {
      value: 'dark_circle_v2',
      label: (
        <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.dark.circle">
          Dark Circles
        </Trans>
      ),
      key: `detectionDescriptionContent.${language.value}.dark_circle_v2`,
      isPremium: false,
      isConcern: true,
    },
  ];
};

const mapCategories = categories =>
  categories.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

const isSkinHealthScoreValid = (values, type, value) => {
  const lowerBound = _get(
    values,
    `skincareHtmlResult.skinHealth.score.avgLowerBound`
  );
  const upperBound = _get(
    values,
    `skincareHtmlResult.skinHealth.score.avgUpperBound`
  );
  return type === 'lower'
    ? parseInt(value) < parseInt(upperBound)
    : parseInt(value) > parseInt(lowerBound);
};

const rangeStyle = {
  verticalAlign: 'middle',
  width: '80px',
  display: 'inline-block',
  textAlign: 'center',
  borderBottom: '4px solid #ccc',
  color: '#ccc',
  margin: '0 10px 12px 10px',
};

const scoreRanges = (version = 1) => [
  {
    key: version === 1 ? 'notGood' : 'fair',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.not.good">
        Fair
      </Trans>
    ),
  },
  {
    key: 'average',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.average">
        Average
      </Trans>
    ),
  },
  {
    key: 'good',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.rate.range.good">
        Good
      </Trans>
    ),
  },
];

const disableEssential = [
  'firmness',
  'droopy_upper_eyelid',
  'droopy_lower_eyelid',
  'radiance',
  'acne',
  'pore',
];

const disableHdEssential = [
  'hd_firmness',
  'hd_droopy_upper_eyelid',
  'hd_droopy_lower_eyelid',
  'hd_wrinkle_forehead',
  'hd_wrinkle_glabellar',
  'hd_wrinkle_periocular',
  'hd_wrinkle_crowfeet',
  'hd_wrinkle_nasolabial',
  'hd_wrinkle_marionette',
  'hd_pore',
  'hd_pore_forehead',
  'hd_pore_nose',
  'hd_pore_cheek',
  'hd_radiance',
  'hd_acne',
  'hd_teartrough',
];

const disabledSkinType = [
  'normal_non_sensitive',
  'dry_non_sensitive',
  'oily_non_sensitive',
  'combination_non_sensitive',
];

const disabledSkinSensitivity = [
  'normal_sensitive',
  'dry_sensitive',
  'oily_sensitive',
  'combination_sensitive',
];

const getDisabledDetectionCategoriesByPlan = auth => {
  const isEnterprise = subscriptionUtils.isEnterprise(auth);
  const analysisInfo = _get(
    multipleSubscriptionsUtils.getSolutionInfos(auth),
    'SKIN_ANALYSIS',
    []
  );
  const isPremiumPlan = _get(analysisInfo, 'isPremiumPlan', 'false');
  const isVersionAbove2AndHd = subscriptionUtils.isSkincareVersionAbove2AndHd(
    auth
  );

  if (isPremiumPlan) {
    return [];
  }
  if (isEnterprise) {
    let enterpriseEnabledDetectionCategory = JSON.parse(
      subscriptionUtils.enterpriseEnabledDetectionCategory(auth)
    );

    if (isVersionAbove2AndHd) {
      return skinDetectionCategories
        .getSkinDetectionReportFlatConcern(false, true, true)
        .filter(
          item => !enterpriseEnabledDetectionCategory.includes(item.value)
        )
        .map(item => item.value);
    }

    return skinDetectionCategories
      .getSkinDetectionReportFlatConcern(false, false, false)
      .filter(item => {
        const isEnabled = enterpriseEnabledDetectionCategory.some(enabled =>
          item.value.includes(enabled)
        );
        return !isEnabled;
      })
      .map(category => {
        if (category === 'spot') return 'age_spot';
        if (category === 'dark_circle_v2') return 'dark_circle';
        return category;
      });
  }

  //isEssential
  if (isVersionAbove2AndHd) {
    return disableHdEssential;
  }
  return disableEssential;
};

const processConcernsByPlan = (concerns, auth, isHd = false) => {
  const plan = subscriptionUtils.isEnterprise(auth)
    ? 'enterprise'
    : subscriptionUtils.isPremiumPlan(auth)
    ? 'premium'
    : 'essential';

  switch (plan) {
    case 'essential': {
      const disableEssentialCategories = isHd
        ? disableHdEssential
        : disableEssential;
      return concerns
        .filter(c => _indexOf(disableEssentialCategories, c.value) === -1)
        .map(c => {
          return {
            label: c.label,
            value: c.value,
            isNew: _get(c, 'isNew', false),
            i18n: c.i18n,
          };
        });
    }
    case 'enterprise': {
      const enabledCategory = JSON.parse(
        subscriptionUtils
          .enterpriseEnabledDetectionCategory(auth)
          .replace('age_spot', 'spot')
      );
      enabledCategory.push('skin_health');
      enabledCategory.push('skin_type');
      enabledCategory.push('sensitive');
      return concerns.filter(c => _indexOf(enabledCategory, c.value) > -1);
    }
    default:
      return concerns;
  }
};

const ruleTypes = () => {
  return [
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.ai.product.recommendation.rule">
          AI Product Recommendation Rules
        </Trans>
      ),
      value: 'ai_rule_based',
    },
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.rulebased..recommendation.rule">
          Rule-Based Recommendation Rules
        </Trans>
      ),
      value: 'rule_based',
    },
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.customized.recommendation.rule">
          Customized Recommendation Rules
        </Trans>
      ),
      value: 'customized',
    },
  ];
};

const ruleStatus = () => {
  return [
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.draft">Draft</Trans>
      ),
      value: 'Draft',
      desc: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.draft.desc">
          One or more products, routines, or treatments in the AI Product
          Recommendation Rule do not yet have Recommended Concerns.
        </Trans>
      ),
    },
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.ready">Ready</Trans>
      ),
      value: 'Active',
      desc: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.ready.desc">
          When the AI Product Recommendation Rule generation is in progress.
        </Trans>
      ),
    },
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.generating">
          Generating
        </Trans>
      ),
      value: 'Generating',
      desc: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.generating.desc">
          All products, routines, and treatments in the AI Product
          Recommendation Rule have Recommended Concerns.
        </Trans>
      ),
    },
    {
      label: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.published">
          Published
        </Trans>
      ),
      value: 'Published',
      desc: (
        <Trans i18nKey="p.s.recommendation.rule.rule.status.published.desc">
          The rule that is online at the time.
        </Trans>
      ),
    },
  ];
};

const operatorDescription = [
  {
    value: '>',
    label: i18n.t('p.s.addoreditskincareroutine.rule.more.than', 'more than'),
  },
  {
    value: '<',
    label: i18n.t('p.s.addoreditskincareroutine.rule.less.than', 'less than'),
  },
  {
    value: '==',
    label: i18n.t('p.s.addoreditskincareroutine.rule.equal.to', 'equal to'),
  },
  {
    value: '>=',
    label: i18n.t(
      'p.s.addoreditskincareroutine.rule.more.than.equal',
      'more than or equal to'
    ),
  },
  {
    value: '<=',
    label: i18n.t(
      'p.s.addoreditskincareroutine.rule.less.than.equal',
      'less than or equal to'
    ),
  },
  {
    value: '<<',
    label: i18n.t('p.s.addoreditskincareroutine.rule.between', 'between'),
  },
  {
    value: '<=<',
    label: i18n.t('p.s.addoreditskincareroutine.rule.between', 'between'),
  },
];

const getPreviewValue = (
  operator,
  score,
  score1,
  score2,
  scoreFormat = 'percentile'
) => {
  const label = _get(
    _find(operatorDescription, d => d.value === operator),
    'label'
  );
  if (operator === '<=<' || operator === '<<') {
    return (
      label +
      ' ' +
      (scoreFormat === 'percentile' ? score1 : (score1 / 10).toFixed(1)) +
      ' ' +
      i18n.t('p.s.recommendationl.view.rule.and', 'and') +
      ' ' +
      (scoreFormat === 'percentile' ? score2 : (score2 / 10).toFixed(1)) +
      ' (' +
      (operator === '<=<'
        ? i18n.t('p.s.recommendationl.view.rule.inclusive', 'inclusive')
        : i18n.t('p.s.recommendationl.view.rule.exclusive', 'exclusive')) +
      ')'
    );
  }
  return (
    label +
    ' ' +
    (scoreFormat === 'percentile' ? score : (score / 10).toFixed(1))
  );
};

const getPreviewIndicator = (indicator, isHd = false, isSubOptions = false) => {
  const scoreType =
    isHd && isSubOptions
      ? transformSubOptionToOption(skinCareHdScoreType)
      : isHd
      ? skinCareHdScoreType
      : skinCareScoreType;

  const skincareType = _find(
    scoreType,
    type => type.value.toLowerCase() === indicator
  );
  return !!skincareType ? skincareType.label : indicator;
};

function getValidIndicator(schema, checkList) {
  const itemIndex = new Map();
  const optionParentIndex = new Map();
  const selectedSet = new Set(checkList);
  const resultSet = new Set();

  for (const item of schema) {
    itemIndex.set(item.value, item);
    for (const opt of item.options || []) {
      optionParentIndex.set(opt.value, item);
    }
  }

  const parentHasRequiredOption = item => {
    const opts = item.options;
    if (!opts || opts.length === 0) return true;
    return opts.some(o => o && o.isRequired === true);
  };

  for (const v of checkList) {
    if (itemIndex.has(v)) {
      const item = itemIndex.get(v);
      if (parentHasRequiredOption(item)) resultSet.add(v);
      continue;
    }

    if (optionParentIndex.has(v)) {
      const parent = optionParentIndex.get(v);
      if (selectedSet.has(parent.value) && parentHasRequiredOption(parent)) {
        resultSet.add(v);
      }
    }
  }

  return Array.from(resultSet);
}

const transformPricesObjectToArray = pricesObject => {
  if (!pricesObject || Object.keys(pricesObject).length === 0) {
    return {pricesArray: [], pricingType: 'fixed'};
  }

  const entries = Object.entries(pricesObject);
  const firstPriceData = entries[0][1];
  if (!firstPriceData || typeof firstPriceData !== 'object') {
    return {pricesArray: [], pricingType: 'fixed'};
  }

  const pricingType = 'originalPrice' in firstPriceData ? 'fixed' : 'variable';

  const pricesArray = entries.map(([currency, priceData]) => {
    const priceItem = {currency};

    if (pricingType === 'fixed') {
      priceItem.originalPrice = priceData.originalPrice.toString();
      priceItem.sellingPrice =
        'sellingPrice' in priceData ? priceData.sellingPrice.toString() : '';
    } else {
      priceItem.lowestPrice = priceData.lowestPrice.toString();
      priceItem.highestPrice =
        'highestPrice' in priceData ? priceData.highestPrice.toString() : '';
    }

    return priceItem;
  });

  return {pricesArray, pricingType};
};

const transformPricesArrayToObject = (pricesArray, pricingType) => {
  if (!pricesArray || !Array.isArray(pricesArray)) {
    return {};
  }

  const isVariablePrice = pricingType === 'variable';
  const pricesFormattedData = {};

  pricesArray.forEach(priceItem => {
    if (priceItem.currency && priceItem.currency.trim() !== '') {
      const priceData = {};

      if (isVariablePrice) {
        if (
          priceItem.lowestPrice !== undefined &&
          priceItem.lowestPrice !== ''
        ) {
          priceData.lowestPrice = parseFloat(priceItem.lowestPrice);
        }
        if (
          priceItem.highestPrice !== undefined &&
          priceItem.highestPrice !== ''
        ) {
          priceData.highestPrice = parseFloat(priceItem.highestPrice);
        }
      } else {
        if (
          priceItem.originalPrice !== undefined &&
          priceItem.originalPrice !== ''
        ) {
          priceData.originalPrice = parseFloat(priceItem.originalPrice);
        }
        if (
          priceItem.sellingPrice !== undefined &&
          priceItem.sellingPrice !== ''
        ) {
          priceData.sellingPrice = parseFloat(priceItem.sellingPrice);
        }
      }

      if (Object.keys(priceData).length > 0) {
        pricesFormattedData[priceItem.currency] = priceData;
      }
    }
  });

  return pricesFormattedData;
};

const validatePrices = data => {
  if (!data.data.isPriceDisplayed) {
    return true;
  }

  const isVariablePrice = data.data.pricingType === 'variable';

  for (let i = 0; i < data.data.prices.length; i++) {
    const priceItem = data.data.prices[i];

    if (!priceItem.currency || String(priceItem.currency).trim() === '') {
      toast.error(
        <Trans i18nKey="p.s.addskincare.price.currency.required">
          Missing required price fields. Please select a currency.
        </Trans>
      );
      return false;
    }

    if (isVariablePrice) {
      if (
        !priceItem.lowestPrice ||
        String(priceItem.lowestPrice).trim() === ''
      ) {
        toast.error(
          <Trans i18nKey="p.s.addskincare.price.lowest.price.required">
            Missing required price fields. Please complete lowest price.
          </Trans>
        );
        return false;
      }

      if (
        priceItem.highestPrice &&
        String(priceItem.highestPrice).trim() !== ''
      ) {
        const lowestPrice = parseFloat(priceItem.lowestPrice);
        const highestPrice = parseFloat(priceItem.highestPrice);
        if (highestPrice < lowestPrice) {
          toast.error(
            <Trans i18nKey="p.s.addskincare.price.highest.price.invalid">
              Highest price must be greater than lowest price.
            </Trans>
          );
          return false;
        }
      }
    } else {
      if (
        !priceItem.originalPrice ||
        String(priceItem.originalPrice).trim() === ''
      ) {
        toast.error(
          <Trans i18nKey="p.s.addskincare.price.original.price.required">
            Missing required price fields. Please complete original price.
          </Trans>
        );
        return false;
      }

      if (
        priceItem.sellingPrice &&
        String(priceItem.sellingPrice).trim() !== ''
      ) {
        const originalPrice = parseFloat(priceItem.originalPrice);
        const sellingPrice = parseFloat(priceItem.sellingPrice);
        if (sellingPrice > originalPrice) {
          toast.error(
            <Trans i18nKey="p.s.addskincare.price.selling.price.invalid">
              Selling price must be lower than original price.
            </Trans>
          );
          return false;
        }
      }
    }
  }

  return true;
}
const exportUIConfigTemplate = async (
  templateId,
  fileName,
  onSuccess,
  onError
) => {
  try {
    const response = await skincareProDao.exportUIConfigTemplate(templateId);
    const binaryStream = await response.blob();
    downloadFile(binaryStream, fileName);
    if (onSuccess) onSuccess();
  } catch (error) {
    if (error && error.status === 400 && typeof error.json === 'function') {
      try {
        const errorData = await error.json();
        const errorType = _get(errorData, 'errors[0].type');

        if (errorType === 'Forbidden') {
          if (onError) onError({...error, isForbidden: true});
          return;
        }
      } catch (parseError) {
         if (onError) {
          onError({...error, parseError});
          return;
        }
      }
    }

    if (onError) onError(error);
  }
};

// for Generic UI Config templates
const handleGenericTemplateExport = async ({
  templateId,
  fileName,
  setIsExporting,
  isDirty = false,
  setModalState,
}) => {
  if (isDirty && setModalState) {
    setModalState({isShow: true, type: 'unsavedChanges', showFooter: true});
    return;
  }

  setIsExporting(true);
  const downloadDate = new Date()
    .toISOString()
    .split('T')[0]
    .replace(/-/g, '');

  await exportUIConfigTemplate(
    templateId,
    `${fileName}_${downloadDate}.zip`,
    () => {
      setIsExporting(false);
    },
    error => {
      setIsExporting(false);
      if (error.isForbidden && setModalState) {
        setModalState({isShow: true, type: 'outdatedConfig', showFooter: true});
      } else {
        toast.error(
          <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
        );
      }
    }
  );
};

// for User Consent & Customized UI Config templates
const handleTemplateExport = async ({templateId, fileName, setIsExporting}) => {
  setIsExporting(true);
  const downloadDate = new Date()
    .toISOString()
    .split('T')[0]
    .replace(/-/g, '');

  const fullFileName = `${fileName}_${downloadDate}.zip`;

  await exportUIConfigTemplate(
    templateId,
    fullFileName,
    () => {
      setIsExporting(false);
      toast.success(<Trans i18nKey="toast.success.success">Success</Trans>);
    },
    () => {
      setIsExporting(false);
      toast.error(
        <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
      );
    }
  );
};

const ALIAS_TO_SCORE_KEY = {
  spot: 'age_spot',
  darkCircle: 'dark_circle_v2',
};

const getConcernOrderWithScore = (category, categoryDisplayOrder, scoreMap) => {
  if (!category || category.length === 0) return null;

  const getScoreKey = key => ALIAS_TO_SCORE_KEY[key] || key;
  const toEntry = key => ({[key]: _get(scoreMap, `${getScoreKey(key)}.score`, 0)});

  if (categoryDisplayOrder === 'manual' || !categoryDisplayOrder) {
    return category.map(toEntry);
  }

  const hasSkinHealth = category.includes('skin_health');
  const items = category.filter(key => key !== 'skin_health');

  const parents = [];
  const childrenMap = {};

  items.forEach(key => {
    if (key.startsWith('hd_wrinkle_')) {
      (childrenMap['hd_wrinkle'] = childrenMap['hd_wrinkle'] || []).push(key);
    } else if (key.startsWith('hd_pore_')) {
      (childrenMap['hd_pore'] = childrenMap['hd_pore'] || []).push(key);
    } else {
      parents.push(key);
    }
  });

  const sortByScore = (a, b) => {
    const scoreA = _get(scoreMap, `${getScoreKey(a)}.score`, 0);
    const scoreB = _get(scoreMap, `${getScoreKey(b)}.score`, 0);
    return categoryDisplayOrder === 'asc' ? scoreA - scoreB : scoreB - scoreA;
  };

  parents.sort(sortByScore);
  Object.values(childrenMap).forEach(children => children.sort(sortByScore));

  const sorted = parents.flatMap(parent => [
    parent,
    ...(childrenMap[parent] || []),
  ]);

  return [
    ...(hasSkinHealth ? [toEntry('skin_health')] : []),
    ...sorted.map(toEntry),
  ];
};

export {
  uploadFile,
  dataURLtoFile,
  handleImage,
  listDevices,
  zipGenerate,
  getTemplateDefaultConfig,
  getOverview,
  getImpression,
  getGetReport,
  getSessionStart,
  getDiagnostic,
  detectionType,
  displayOrder,
  skincareSkuTypes,
  skinCareScoreType,
  skinCareHdScoreType,
  getSkinCareFlatScoreType,
  getDetectionLanguages,
  getCurrencyOptions,
  getHtmlLanguages,
  mappingDisable,
  arrayMapping,
  arrayMappingValue,
  transformSubOptionToOption,
  getCategory,
  getProductList,
  processRuleData,
  removeSurveyCases,
  removeEmptyCase,
  processAiRuleData,
  getTemplate,
  getTemplateLayout,
  updateTemplate,
  publishConfig,
  getBrandId,
  descriptionContent,
  mapCategories,
  isSkinHealthScoreValid,
  migrateTemplateV2,
  processV1toV2Data,
  rangeStyle,
  scoreRanges,
  processConcernsByPlan,
  treatmentTypes,
  facialZones,
  combineTreatments,
  ruleTypes,
  ruleStatus,
  productTypes,
  productTypesName,
  skinAiRuleIndicators,
  skinHdAiRuleIndicators,
  skinTypeAiRuleIndicators,
  faceAssessmentCategory,
  generationStatus,
  operatorDescription,
  getPreviewValue,
  getPreviewIndicator,
  getValidIndicator,
  disableEssential,
  disableHdEssential,
  disabledSkinType,
  disabledSkinSensitivity,
  getDisabledDetectionCategoriesByPlan,
  transformPricesObjectToArray,
  transformPricesArrayToObject,
  validatePrices,
  exportUIConfigTemplate,
  handleGenericTemplateExport,
  handleTemplateExport,
  getConcernOrderWithScore,
};
